/**
 * Cardano block explorer URL helpers (Cexplorer.io).
 * Used when the app is built with VITE_CHAIN=cardano.
 */

function baseUrl(network: string): string {
  const n = (network || 'preview').toLowerCase();
  if (n === 'mainnet') return 'https://cexplorer.io';
  return `https://${n}.cexplorer.io`;
}

export function getCardanoTxUrl(txHash: string, network = 'preview'): string {
  return `${baseUrl(network)}/tx/${txHash}`;
}

export function getCardanoAddressUrl(address: string, network = 'preview'): string {
  return `${baseUrl(network)}/address/${address}`;
}

/**
 * Asset page URL. Accepts either `policyId.assetName` or raw `policyIdassetName`.
 */
export function getCardanoAssetUrl(
  policyIdDotAssetName: string,
  network = 'preview',
): string {
  const raw = policyIdDotAssetName.replace('.', '');
  return `${baseUrl(network)}/asset/${raw}`;
}

/** Parse the `did:cardano:<network>:<policyId>.<assetName>` form into parts. */
export function parseCardanoDid(
  did: string,
): { network: string; policyId: string; assetName: string } | null {
  const m = did.match(/^did:cardano:([^:]+):([0-9a-f]+)\.([0-9a-f]+)$/i);
  if (!m) return null;
  return { network: m[1], policyId: m[2], assetName: m[3] };
}
